import * as React from 'react';
import { Route } from 'react-router-dom';
import { AlertList } from './AlertList';

export const AlertView = () => {
    return (
        <>
            <Route path="/admin/contract-expiration-alerts" exact component={AlertList} />
        </>
    );
};
